<template>
    <div class="global">
        <!-- banner -->
        <div class="banner">
            <div class="img"><img src="@/assets/img/global_banner.png" alt=""></div>
        </div>
        <!-- 签证国家、地区 -->
        <div class="country">
            <p class="title">签证国家/地区</p>
            <ul>
                <li v-for="(item,index) in countryList" :key="index" @click="goDetails(item.name)">
                    <div class="logo"><img :src="item.img" alt=""></div>
                </li>
            </ul>
        </div>
        <!-- 底部品牌宣传 
        <div class="service">
            <p class="title">底部品牌宣传</p>
        </div>-->
    </div>
</template>

<script>

export default {
    data() {
        return {
            countryList:[{
                img:require("@/assets/img/global_mg.png"),
                name:'美国'
            },{
                img:require("@/assets/img/global_yg.png"),
                name:'英国'
            },{
                img:require("@/assets/img/global_oz.jpg"),
                name:'欧洲'
            },{
                img:require("@/assets/img/global_xjp.png"),
                name:'新加坡'
            },{
                img:require("@/assets/img/global_rb.png"),
                name:'日本'
            },{
                img:require("@/assets/img/global_jnd.png"),
                name:'加拿大'
            },{
                img:require("@/assets/img/global_xg.png"),
                name:'香港'
            },{
                img:require("@/assets/img/global_hg.png"),
                name:'韩国'
            }
            // {
            //     img:require("@/assets/img/global_dg.png"),
            //     name:'德国'
            // },{
            //     img:require("@/assets/img/global_rs.png"),
            //     name:'瑞士'
            // },{
            //     img:require("@/assets/img/global_fg.png"),
            //     name:'法国'
            // },{
            //     img:require("@/assets/img/global_hl.png"),
            //     name:'荷兰'
            // },{
            //     img:require("@/assets/img/global_adl.png"),
            //     name:'奥地利'
            // },
            ],
        }
    },
    methods:{
        // 详情
        goDetails(name){
            this.$router.push({
                path:"/globaldetails",
                query:{
                    name:name
                }
            })
        }      
    }
}
</script>

<style lang="less" scoped>
.global {
    background:#fff;
    padding-bottom:150px;
    // font-family: 'PingFang Regular';
    .banner {
        width: 100%;
        height: 287px;
        position: relative;
        background:#999;
        .img {
            width: 100%;
            img {
                width: 100%;
            }
        }
    }
    .country{
        // border-bottom:20px solid #f5f5f5;
        padding:0px 25px 50px;
        .title{
            text-align: center;
            color:#1A1A1A;
            font-size: 38px;
            padding:60px 0 50px;
            line-height: 38px;
        }
        ul{
            width:100%;
            li{
                width: calc(~"(100% - 54px) / 4");
                display: inline-block;
                margin: 0 18px 18px 0;
                border-radius: 10px;
                text-align: center;
                // font-family:"PingFang SC";
                .logo {
                    width: 100%;
                    img {
                        width: 100%;
                    }
                }
                &:nth-child(4n) {
                    margin-right: 0px;
                }
            }
        }
    }
    .service{
        .title{
           text-align: center;
           color:#1A1A1A;
           font-size: 38px;
           padding:60px 0 70px;
           line-height: 38px;
       }
    }
}
</style>